import React, { useEffect, useRef, useState, useCallback } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import debounce from 'lodash.debounce';
import { clone } from 'ramda';
import { TextInput, PopupMenu } from 'quantux-ui';
import CaseUserCard from '../revenue-cycle-management/case-user-card';
import { BASE_URL, getHighlightedText } from '../../utils';
import { blue, gray, yellow } from '../../theme';

const drawerWidth = window.innerWidth <= 700 ? window.innerWidth : 375;
const defaultDescription = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.";

const About = (props) => {
  const [showProceduresMenu, setShowProceduresMenu] = useState(false);
  const [procedureValue, setProcedureValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const surgicalProceduresRef = useRef();

  const searchSurgicalProcedures = (value) => {
    const url = new URL(`${BASE_URL}/cpt/searchCpt2`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setSearchResults(data.cptCodes);
      })
      .catch(error => console.log('error', error));
  };
  const debouncedSurgicalProceduresSearch = useCallback(debounce(value => searchSurgicalProcedures(value), 500), []);

  useEffect(() => {
    if (procedureValue.length === 0) {
      setSearchResults([]);
    }
    if (procedureValue.length > 0) {
      debouncedSurgicalProceduresSearch(procedureValue);
    }
  }, [procedureValue]);

  const styles = StyleSheet.create({
    aboutTextContainer: {
      whiteSpace: 'pre-wrap',
      overflowWrap: 'break-word'
    },
    caseUserCardContainer: {
      marginTop: '24px',
      width: '370px'
    },
    procedureMenuPlaceholderContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    proceduresMenuContainer: {
      width: '370px',
      minHeight: '120px',
      maxHeight: '300px',
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto'
    },
    menuItem: {
      cursor: 'pointer',
      background: '#103860',
      borderRadius: '8px',
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      fontSize: '14px',
      marginBottom: '2px',
      ':hover': {
        background: '#184878',
        color: 'white'
      },
      ':last-child': {
        borderBottom: '0'
      }
    },
    menuItemTextContainer: {
      flexGrow: '1',
      justifyContent: 'space-between'
    },
    menuItemText: {
      display: 'flex',
      // height: '40px',
      padding: '4px',
      alignItems: 'center'
      // textTransform: 'lowercase',
      // 'span:first-letter': {
      //   textTransform: 'uppercase'
      // }
    },
    menuItemStarContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: '0',
      fontSize: '28px',
      width: '40px',
      ':hover': {
        color: yellow[500]
      }
    },
    isFav: {
      color: yellow[500]
    }
  });

  return (
    <div className={`${props.className} ${css(styles.aboutTextContainer)}`}>
      {props.description.length > 0
        ? props.description
        : defaultDescription
      }
      <div
        className={css(styles.caseUserCardContainer)}
        style={{ display: props.isSurgeon ? '' : 'none' }}
      >
        <div
          ref={surgicalProceduresRef}
          className='mt-2'
          style={{
            border: `1px solid ${blue[700]}`,
            borderRadius: '4px',
            position: 'relative'
          }}
        >
          <TextInput
            value={procedureValue}
            placeholder="Enter procedure here OR select procedure from list below"
            style={{
              width: `${drawerWidth - 7}px`,
              fontSize: '14px',
              padding: '0 4px',
              color: blue[200],
              borderRadius: '4px'
            }}
            onChange={(e) => {
              const { value } = e.target;
              setProcedureValue(value);
            }}
            onClick={() => setShowProceduresMenu(true)}
          />
          {showProceduresMenu &&
            <PopupMenu
              top={35}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showProceduresMenu}
              parent={surgicalProceduresRef}
              onOutsideClick={() => { setShowProceduresMenu(false); }}
            >
              <div className={css(styles.proceduresMenuContainer, (searchResults.length === 0) && styles.procedureMenuPlaceholderContainer)}>
                {/* Menu Items */}
                {searchResults.map((el) => {
                  const isFav = props.surgicalProcedures.findIndex(proc => proc.code === el.code) >= 0;
                  return (
                    <div
                      key={el._id}
                      className={`fx fx__v-center ${css(styles.menuItem)}`}
                    >
                      <div className='fx ml-2' style={{ flexGrow: '1', justifyContent: 'space-between' }}>
                        <div className={css(styles.menuItemText)}>
                          {getHighlightedText(el.longDescription, procedureValue)}
                        </div>
                        <div className={css(styles.menuItemStarContainer, isFav && styles.isFav)}>
                          <i
                            className='fa fa-star'
                            onClick={() => {
                              const idx = props.surgicalProcedures.findIndex(proc => proc.code === el.code);
                              if (idx >= 0) {
                                const tmpProc = clone(props.surgicalProcedures[idx]);
                                props.onRemove(tmpProc);
                              } else {
                                props.onFav(el);
                              }
                              setShowProceduresMenu(false);
                              setProcedureValue('');
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Placeholder message */}
                {searchResults.length === 0 &&
                  <div>Search Surgical Procedure in the text box above</div>
                }
              </div>
            </PopupMenu>
          }
        </div>
        {props.surgicalProcedures.map((el) => (
          <CaseUserCard
            className='mt-1'
            avatarImageUrl=''
            showCloseIcon
            showAlert={false}
            noAvatar
            key={el._id}
            dataId={el._id}
            onClose={(id) => {
              const idx = props.surgicalProcedures.findIndex(el => el._id === id);
              const tmpProc = clone(props.surgicalProcedures[idx]);
              props.onRemove(tmpProc);
            }}
          >
            <div style={{ fontSize: '12px', marginLeft: '8px' }}>
              <div>
                {`${el.shortDescription} ${el.code !== 'N/A' ? `(${el.code})` : ''}`}
              </div>
            </div>
          </CaseUserCard>
        ))}
      </div>
    </div>
  );
};

About.defaultProps = {
  surgicalProcedures: [],
  description: '',
  isSurgeon: false,
  onFav: () => {}
};

export default About;
